/**
 * Shared validation error strings used in client-side form checks.
 *
 * These mirror the literals emitted by the backend (see
 * backend/src/validation/country.ts) so that pre-flight form errors and
 * server-side errors read identically to the user.
 */

export const COUNTRY_REQUIRED_ERROR = 'At least one country must be selected';

/**
 * Maximum length for a brand blueprint description. Enforced client-side only
 * (backend stores description as an unconstrained MySQL text column). Applied
 * to both the create dialog (Explore) and the create/edit form (PromptManager).
 */
export const MAX_BLUEPRINT_DESCRIPTION = 300;
